import uniqBy from 'lodash.uniqby';

export default function makeSimpleMetrics (metrics) {
    const unique = uniqBy(metrics, 'simple_id');
    return unique.map(m => {
        if (!m.goal_id && !m.profile_id){
            return m;
        }
        return {
            ...m,
            id: m.simple_id,
            name: m.name.split('"')[0]
        };
    });
}
